export const TRADE_QUOTE_CURRENCY = "USDT";

const getTradePairSlug = (coin, futuresPairsSlugsSet) => {
  if (!futuresPairsSlugsSet) {
    return null;
  }

  const baseSymbol = String(coin.symbol || "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");
  const candidateSlug = `${baseSymbol}${TRADE_QUOTE_CURRENCY}`;

  return futuresPairsSlugsSet.has(candidateSlug) ? candidateSlug : null;
};

export default getTradePairSlug;
